export default __webpack_public_path__ + "static/media/defused.21c21d44.gif";